module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
if(isMandatory){

    ; __append("\r\n    <img class=\"pf-badge\" src=\"")
    ; __append( require('editor/icons/marker_obligatory.png') )
    ; __append("\" alt=\"\">\r\n")
    ; 
}

    ; __append("\r\n")
    ; 
if(isNormal){

    ; __append("\r\n    <img class=\"pf-badge\" src=\"")
    ; __append( require('editor/icons/marker_normal.png') )
    ; __append("\" alt=\"\">\r\n")
    ; 
}

    ; __append("\r\n")
    ; 
if(isHidden){

    ; __append("\r\n    <img class=\"pf-badge\" src=\"")
    ; __append( require('editor/icons/marker_hidden.png') )
    ; __append("\" alt=\"\">\r\n")
    ; 
}

    ; __append("\r\n")
    ; 
if(isDisabled){

    ; __append("\r\n    <img class=\"pf-badge\" src=\"")
    ; __append( require('editor/icons/marker_disabled.png') )
    ; __append("\" alt=\"\">\r\n")
    ; 
}

    ; __append("\r\n")
    ; 
if(isReadOnly){

    ; __append("\r\n    <img class=\"pf-badge\" src=\"")
    ; __append( require('editor/icons/marker_readonly.png') )
    ; __append("\" alt=\"\">\r\n")
    ; 
}

    ; __append("\r\n\r\n\r\n\r\n\r\n")
  }
  return __output;

}